// import $ from 'jquery';
// import React from 'react-dom';
// import ReactDOM from 'react-dom';
// import { convertToBoolean } from '_utils';
import config from 'store/_config'
import _ from 'lodash'
import { axiosInstance as axios, handleAxiosErrors, createAxiosCancellationToken } from '_utils'
import { push, replace } from 'connected-react-router'
import { storageAvailable } from '_utils'
import { LS } from 'store/localStorage'
import {
  getStartingIndex,
  isNewArrivalRequest,
  isSearchRequest,
  buildRequestProductListParams,
} from '../selectors/defaultSelectors'
import { ActionCreators } from 'redux-undo'
import { handleProductResponse } from '../../dashboard/actions/productsActions'
import { getProductsImage } from '../../dashboard/selectors/productSelectors'
// import { getProductImage } from '../../dashboard/selectors/converterSelectors'

let cancelToken = {}

export const toggleProductsLoading = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'TOGGLE_PRODUCTS_LOADING',
      value: value,
    })
  }
}
export const UndoRedo = (location, action) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { history } = state;
    const { key } = location
    const { history } = state.products.present

    // prevent any action if it is a PUSH
    if (action !== 'POP') return

    if (key && history.indexOf(key) === history.length - 1) {
      dispatch(ActionCreators.redo())
    } else {
      dispatch(ActionCreators.undo())
    }
  }
}

export const changePagination = (page, type) => {
  return (dispatch, getState) => {
    const state = getState()

    let url = '',
      appendPageUrl = ''
    if (state.router.location.search !== '') {
      url = getHistoryURL(state.router.location.search, 'search')
      appendPageUrl = `&page=${page + 1}`
    } else {
      url = getHistoryURL(state.router.location.pathname, 'pathname')
      appendPageUrl = `page/${page + 1}/`
    }

    if (page > 0) {
      url += appendPageUrl
    }

    dispatch(changeActivePage(page + 1, type))
    // dispatch(push(url));
    dispatch(replace(url))
  }
}
export const changeSearch = (params) => {
  return (dispatch, getState) => {
    Promise.all([dispatch(updateSearchQuery(params.search))]).then(() => {
      dispatch(changeActivePage(1))
    })
  }
}
export const updateSearchQuery = (keyword) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'UPDATE_PRODUCTS_SEARCH',
      value: keyword,
    })
  }
}
export const setProductsFilters = () => {
  let productFilters = {},
    hasPreselectedFilters = false

  if (typeof window.selectedBrandFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Brand = _.keyBy(
      window.selectedBrandFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }
  if (typeof window.selectedCountryFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Country = _.keyBy(
      window.selectedCountryFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }
  if (typeof window.selectedRegionFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.Region = _.keyBy(
      window.selectedRegionFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }
  if (typeof window.selectedContainerTypeFilters == 'object') {
    hasPreselectedFilters = true
    productFilters.ContainerType = _.keyBy(
      window.selectedContainerTypeFilters.map((item, index) => ({ index, value: item, checked: false })),
      'index'
    )
  }

  if (hasPreselectedFilters) {
    return (dispatch, getState) => {
      dispatch({
        type: 'SET_PRODUCTS_FILTERS',
        value: productFilters,
      })
    }
  }
}
export const setPerPage = (perPage) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PER_PAGE',
      value: perPage,
    })
  }
}
export const setSort = (sort) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_SORT',
      value: sort,
    })
  }
}
export const setPerPageFromStorage = (perPage) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage') && LS.get('perPage')) {
      dispatch(setPerPage(LS.get('perPage')))
    }
  }
}
export const setActivePage = (page) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_ACTIVE_PAGE',
      value: page,
    })
  }
}
export const setTotalPages = (value) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_TOTAL_PAGES',
      value: value,
    })
  }
}
export const initializeSelectedFilters = () => {
  return (dispatch, getState) => {
    if (typeof window.brand != 'undefined') {
      dispatch(applyInitializedFilters('Brand', window.brand))
    }
    if (typeof window.country != 'undefined') {
      dispatch(applyInitializedFilters('Country', window.country))
    }
    if (typeof window.region != 'undefined') {
      dispatch(applyInitializedFilters('Region', window.region))
    }
  }
}
export const applyInitializedFilters = (type, value) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters } = state.products.present
    const finalValue = decodeURI(value)

    let newFilters = {
      ...filters,
      ...{
        [type]: {
          [finalValue]: {
            id: finalValue,
            value: finalValue,
            checked: true,
          },
        },
      },
    }

    dispatch({
      type: 'SET_PRODUCTS_FILTERS',
      value: newFilters,
    })
  }
}
export const toggleActiveFilters = (flag) => {
  return {
    type: 'TOGGLE_ACTIVE_FILTERS',
    value: flag,
  }
}
export const toggleFilter = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    // const { key, index } = params; // TODO: remove this
    const { key, id } = params
    let filters = state.products.present.filters

    dispatch({
      type: 'TOGGLE_FILTER',
      value: {
        ...filters,
        [key]: {
          ...filters[key],
          [id]: {
            ...filters[key][id],
            checked: !filters[key][id].checked,
          },
          // TODO: remove this
          // [index]: {
          //     ...filters[key][index],
          //     checked: !filters[key][index].checked
          // }
        },
      },
    })
    dispatch(reloadFilters())
  }
}
export const clearFiltersByCategory = (category) => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.products.present.filters
    const target = filters[category]
    Object.values(target).map((item, idnex) => {
      item.checked = false
    })

    dispatch({
      type: 'TOGGLE_FILTER',
      value: {
        ...filters,
        [category]: target,
      },
    })
    dispatch(reloadFilters())
  }
}
export const reloadFilters = () => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.products.present.filters

    let url = ''
    if (state.router.location.search !== '') {
      url = getHistoryURL(state.router.location.search, 'search')
    } else {
      url = getHistoryURL(state.router.location.pathname, 'pathname')
    }

    dispatch(setActivePage(1))
    if (checkIfThereAreFiltersActive(filters)) {
      // dispatch(push(url));
      dispatch(replace(url))
      dispatch(toggleActiveFilters(true))
      // dispatch(requestFilteredProductsList({ startingIndex: 0 }));
    } else {
      dispatch(toggleActiveFilters(false))
      // dispatch(requestProductsList({ startingIndex: 0 }));
    }

    dispatch(requestFilters())
    dispatch(requestProductsList({ startingIndex: 0 }))
  }
}
export const changeActivePage = (page, type) => {
  return (dispatch, getState) => {
    dispatch(setActivePage(page))
    dispatch(refreshCurrentView(type))
  }
}
export const changePerPage = (amount, type) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('perPage', amount)
    }

    dispatch(setPerPage(amount))
    dispatch(refreshCurrentView(type))
  }
}
export const changeSort = (sort) => {
  return (dispatch, getState) => {
    dispatch(setSort(sort))
    dispatch(refreshCurrentView())
  }
}
export const changeTableView = (tableView) => {
  return (dispatch, getState) => {
    if (storageAvailable('localStorage')) {
      LS.set('tableView', tableView)
    }
    dispatch({
      type: 'SET_TABLE_VIEW',
      value: tableView,
    })
  }
}
export const refreshCurrentView = (type) => {
  return (dispatch, getState) => {
    const state = getState()
    const filters = state.products.present.filters
    const { activePage, perPage } = getState().products.present

    if (checkIfThereAreFiltersActive(filters)) {
      // dispatch(toggleActiveFilters(true));
      dispatch(
        requestProductsList({
          startingIndex: getStartingIndex(perPage, activePage),
        })
      )
    } else {
      // dispatch(toggleActiveFilters(false));
      dispatch(
        requestProductsList({
          startingIndex: getStartingIndex(perPage, activePage),
        })
      )
    }
  }
}
export const requestFilters = () => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters = {} } = state.products.present ? state.products.present : state.products

    const { ContainerType, Brand, Region, Country, Style, Varietal } = filters

    let { url, query } = config.filters.list

    let containerType = getFilterValues(ContainerType)
    let varietal = getFilterValues(Varietal)
    let style = getFilterValues(Style)
    let country = getFilterValues(Country)
    let region = getFilterValues(Region)
    let brand = getFilterValues(Brand)

    let params = {}

    if (window.searchKeyword !== undefined) {
      params['q'] = window.searchKeyword
    }
    if (window.categoryURL !== undefined) {
      params['CategoryURL'] = window.categoryURL
    }
    if (containerType?.length > 0) {
      params['ContainerType'] = containerType
    }
    if (varietal?.length > 0) {
      params['Varietal'] = varietal
    }
    if (style?.length > 0) {
      params['LiquorStyle'] = style
    }
    if (country?.length > 0) {
      params['Country'] = country
    }
    if (region?.length > 0) {
      params['Region'] = region
    }
    if (brand?.length > 0) {
      params['Brand'] = brand
    }

    if (cancelToken.productFilters) {
      cancelToken.productFilters.cancel()
    }

    cancelToken.productFilters = createAxiosCancellationToken()

    return axios
      .post(
        url,
        {
          query: query,
          variables: params,
        },
        {
          cancelToken: cancelToken.productFilters.token,
          // withCredentials: true
        }
      )
      .then((response) => {
        /* 
          Convert LiquorStyle to Style before filters merging as BE is expecting LiquorStyle in params and returing 
          Style in response.
        */
        if (params['LiquorStyle']) {
          params['Style'] = params['LiquorStyle']
          delete params['LiquorStyle']
        }

        /* 
          Check if there are already filters available, then merge same filters available in old and new filters list
          and if the old filters are not available in new filters list then just set old filter count to 0 and do not 
          hide it on web. 
        */
        let newFilters = {}

        if (Object.keys(filters)?.length > 0) {
          let filterdData = convertFiltersToAReadableFormat(response.data.data.productFilters, params, true)
          newFilters = mergeProductsFiltersData(filters, filterdData)
        } else {
          newFilters = convertFiltersToAReadableFormat(response.data.data.productFilters, params)
        }

        dispatch({
          type: 'SET_PRODUCTS_FILTERS',
          value: newFilters,
        })
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const requestFilteredProductsList = (params) => {
  return (dispatch, getState) => {
    const state = getState()
    const { filters, perPage } = state.products.present
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
    const { startingIndex } = params

    // Handle selected filter
    // const selectedBrandFilters = getFilterValues(Brand, 'value', (data) => data.replace(/\s/g, '_'));
    const selectedContainerTypeFilters = getFilterValues(ContainerType)
    const selectedBrandFilters = getFilterValues(Brand)
    const selectedRegionFilters = getFilterValues(Region)
    const selectedCountryFilters = getFilterValues(Country)
    const selectedStyleFilters = getFilterValues(Style)
    const selectedTypeFilters = getFilterValues(Type)
    const selectedVarietalFilters = getFilterValues(Varietal)

    let { url } = config.products.filters
    url = url
      .replace('{groupID}', window.groupID)
      .replace('{startingIndex}', startingIndex)
      .replace('{amount}', perPage)

    if (isNewArrivalRequest()) {
      url = url.replace('catid={category}', 'newarrivalsonly=1')
      url = url.replace('SortableTitle:asc', 'EnTimeCreated:desc')
    } else {
      url = url.replace('{category}', window.categoryID)
    }

    if (selectedBrandFilters) {
      url += '&brand=' + selectedBrandFilters
    }
    if (selectedRegionFilters) {
      url += '&region=' + selectedRegionFilters
    }
    if (selectedCountryFilters) {
      url += '&country=' + selectedCountryFilters
    }
    if (selectedStyleFilters) {
      url += '&style=' + selectedStyleFilters
    }
    if (selectedTypeFilters) {
      url += '&ptype=' + selectedTypeFilters
    }
    if (selectedVarietalFilters) {
      url += '&varietal=' + selectedVarietalFilters
    }

    dispatch(toggleProductsLoading(true))

    return axios
      .get(url, {
        // withCredentials: true
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.hits.hits)
        const totalProducts = response.data.hits.total
        dispatch(toggleProductsLoading(false))
        dispatch(updateFilteredProductsList(products, totalProducts))
      })
      .catch((error) => handleAxiosErrors(error))
  }
}
export const buildRequestProductListUrl = (params) => {
  let { url, query } = config.products.listing
  let urlParams = []

  if (isNewArrivalRequest()) {
    urlParams.push('newarrivalsonly=1')
    url = url.replace('SortableTitle:asc', 'EnTimeCreated:desc')
  } else if (!isSearchRequest()) {
    if (window.categoryID) {
      urlParams.push('catid=' + window.categoryID)
    }
  }

  Object.entries(params).map(([key, value]) => {
    if (typeof value != 'undefined' && value) {
      urlParams.push(`${key}=${value}`)
    }
  })

  if (urlParams.length > 0) {
    url += '&' + urlParams.join('&')
  }

  return {
    url,
    query,
  }
}

export const requestProductsByIDs = (uniqueProductIDs, callback) => {
  return (dispatch, getState) => {
    const state = getState()

    let { url, query } = config.products.details

    return axios
      .post(
        url,
        {
          query: query,
          variables: {
            IDs: uniqueProductIDs.map((ID) => Number(ID)),
          },
        },
        {
          withCredentials: true,
        }
      )
      .then((response) => {
        let loggedIn = document.getElementById('ScrollableIsLoggedIn') ? true : false
        handleProductResponse(dispatch, state, { loadPriceSeparately: !loggedIn }, response, callback)
      })
      .catch((error) => handleAxiosErrors(error))
  }
}

export const requestProductsList = (params) => {
  return async (dispatch, getState) => {
    const state = getState()
    const { filters = {}, perPage, searchKeyword, sort } = state.products.present
      ? state.products.present
      : state.products
    const { ContainerType, Brand, Region, Country, Style, Type, Varietal } = filters
    const { startingIndex, blockID } = params

    let { url, query } = config.products.listing
    let q = searchKeyword || window.searchKeyword

    query = query.replace(
      /{params}/,
      buildRequestProductListParams({
        q,
        CategoryURL: window.categoryURL,
        limit: perPage,
        offset: startingIndex || 0,
        ContainerType: getFilterValues(ContainerType),
        Varietal: getFilterValues(Varietal),
        LiquorStyle: getFilterValues(Style),
        Country: getFilterValues(Country),
        Region: getFilterValues(Region),
        Brand: getFilterValues(Brand),
        DisplayPrice__gte: 0,
        DisplayPrice__lte: 10000,
        BlockID: parseInt(blockID) || 0,
        Sort: sort,
      })
    )

    dispatch(toggleProductsLoading(true))

    if (cancelToken.searchResult) {
      cancelToken.searchResult.cancel()
    }

    cancelToken.searchResult = await createAxiosCancellationToken()

    return await axios
      .get(url, {
        params: {
          query: query,
        },
        cancelToken: cancelToken.searchResult.token,
      })
      .then((response) => {
        const products = convertProductsListingToAReadableFormat(response.data.data.searchResult.edges)
        const totalProducts = response.data.data.searchResult.pageInfo.totalCount
        dispatch(toggleProductsLoading(false))
        dispatch(updateProductsList(products, blockID, totalProducts))
      })
      .catch((error) => {
        return handleAxiosErrors(error)
      })
  }
}
export const updateFilteredProductsList = (productsList, totalProducts) => {
  return (dispatch, getState) => {
    const state = getState()
    const { list, activePage, perPage } = state.products.present
    const startingIndex = getStartingIndex(perPage, activePage)
    let newList = [...list]

    // create a total new list when sizes don't match
    if (totalProducts != list.length) {
      newList = Array.apply(null, { length: totalProducts })
    }

    productsList.map((item, index) => {
      newList[startingIndex + index] = item
    })

    dispatch(setProductsList(newList))
  }
}
export const updateProductsList = (productsList, blockID, totalProducts) => {
  return (dispatch, getState) => {
    const state = getState()
    const { perPage } = state.products.present

    const newList = productsList.map((item, index) => {
      return item
    })

    if (blockID) {
      dispatch(setProductsScrollableList(newList, blockID))
    } else {
      dispatch(setProductsList(newList))
    }

    dispatch(setTotalPages(Math.ceil(totalProducts / perPage)))
  }
}
export const setProductsList = (list) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_LIST',
      list: list,
    })
  }
}

export const setProductsScrollableList = (list, blockID) => {
  return (dispatch, getState) => {
    dispatch({
      type: 'SET_PRODUCTS_SCROLLABLE_LIST',
      list: list,
      blockID: blockID,
    })
  }
}
export const getFilterValues = (list, key = 'value', callback) => {
  if (typeof list == 'undefined' || list == null) {
    return []
  }

  const newList = Object.values(list).reduce((values, item) => {
    // if (values.length > 0) return values; // TODO: remove this
    if (item.checked) {
      let pushedValue = item[key]

      // values.push(item.value);
      if (typeof callback != 'undefined' && callback) {
        pushedValue = callback(pushedValue)
      }

      values.push(pushedValue)
    }
    return values
  }, [])

  // return newList.length ? newList.toString().replace(/\s+/g, '_') : '+'; // TODO: remove this
  // return newList.length ? newList.toString().replace(/,/g, '+') : 0;

  return newList
}
export const getHistoryURL = (url, type = 'pathname') => {
  let newUrl = ''

  if (type === 'pathname') {
    newUrl = url.replace(/\/page/, '') // removed /page/
  } else {
    newUrl = url.replace(/&page\=[0-9]+/, '').replace(/\/$/, '') // remove &page=2/
    return newUrl
  }

  const urlArray = newUrl.split('/')
  let lastPos = -1

  if (!isNaN(Number(urlArray[urlArray.length - 2]))) {
    lastPos = -2 // ig no /page/, then -2
  }

  console.log(`/${urlArray.slice(1, lastPos).join('/').replace(',', '/')}/`)

  return `/${urlArray.slice(1, lastPos).join('/').replace(',', '/')}/`
}
export const checkIfThereAreFiltersActive = (filters) => {
  let checked = false
  Object.values(filters).map((item, index) => {
    Object.values(item).map((item, index) => {
      if (item.checked) checked = true
    })
  })
  return checked
}
export const convertProductsListingToAReadableFormat = (list) => {
  const getNumber = ({ value, defaultValue }) => {
    const num = parseInt(value, 10)
    return isNaN(num) ? defaultValue : num
  }

  let newList = []
  list.map((item) => {
    const { node } = item
    const {
      ID,
      InternalItemID,
      URLSegment,
      Title,
      ReSizedProductListingImage,
      ReSizedDefaultImage,
      LoyaltyPoints,
      SplitPackSize,
    } = node[0]

    let image = getProductsImage(node[0])

    newList.push({
      // ProductVariationID
      id: ID,
      productID: InternalItemID,
      url_slug: URLSegment, // TODO
      //image: getProductImage(ReSizedDefaultImage),
      image, // TODO
      title: Title,
      loyaltyPoints: getNumber({ value: LoyaltyPoints, defaultValue: 0 }),
      splitPackSize: SplitPackSize,
      // categories: getProductCategoryIDArray(ProductCategoriesMap),
    })
  })
  return newList
}

/* 
  Added keyByTitle parameter for handling the case when we are merging the old and new filters 
  in mergeProductsFiltersData function
*/
export const convertFiltersToAReadableFormat = (list, activeFilers = {}, keyByTitle = false) => {
  let filters = {}

  // list.forEach((filterGroup) => {
  //   const { Title, Items } = filterGroup

  //   if (filters[Title] === undefined) {
  //     filters[Title] = {}
  //   }

  //   Items.forEach((filterItem) => {
  //     filters[Title][filterItem] = {
  //       id: filterItem,
  //       value: filterItem,
  //       checked: false,
  //     }
  //   })
  // })

  console.log('filters')
  const filterValues = Object.values(JSON.parse(JSON.stringify(list)))
  filterValues.forEach((filterGroup) => {
    const { FilterSort, IsCollapsed, Title, DisplayTitle, Items } = filterGroup
    if (filters[Title] === undefined) {
      filters[Title] = {}
    }
    Object.entries(JSON.parse(Items)).map(([filterItem, filterValue]) => {
      if (filterValue.Title) {
        let key = keyByTitle ? filterValue.Title : filterItem
        filters[Title][key] = {
          id: filterItem,
          value: filterValue.Title,
          title: filterValue.Title,
          displayTitle: DisplayTitle,
          count: filterValue.Count,
          isCollapse: IsCollapsed,
          sortBy: FilterSort,
          checked: activeFilers[Title] && activeFilers[Title]?.includes(filterValue?.Title) ? true : false,
        }
      }
    })
  })

  return filters
}

/* 
  mergeProductsFiltersData function to handle merging of current and new filters 
*/
export const mergeProductsFiltersData = (currFilters, newFilters) => {
  const mergedData = {}

  Object.keys(currFilters).forEach((filter) => {
    mergedData[filter] = {}

    Object.values(currFilters[filter]).forEach((item) => {
      if (item.title) {
        const newItem = newFilters[filter][item.title]
          ? { ...newFilters[filter][item.title], id: item.id }
          : { ...item, id: item.id, count: 0 }
        mergedData[filter][item.id] = newItem
      }
    })
  })

  return mergedData
}
